import { useEffect, useState } from "react";
import {
  useQuery,
  useMutation,
  useQueryClient,
  QueryClient,
  QueryClientProvider,
  useInfiniteQuery,
  keepPreviousData,
  UseInfiniteQueryResult,
} from "@tanstack/react-query";
import { useBanditContext } from "../context/BanditQuestContext";

interface UseQuestProps {
  pageLimit?: number;
  aggregationDisabled?: boolean;
  chain: string;
  address: string;
}

const useQuest = ({
  pageLimit = 12,
  aggregationDisabled,
  chain,
  address,
}: UseQuestProps): UseInfiniteQueryResult => {
  const { questSDK } = useBanditContext();
  const queryClient = useQueryClient();

  const infiniteQuery = useInfiniteQuery({
    queryKey: ["quest-list", chain, address],
    queryFn: async ({ pageParam }) => {
      const res = await questSDK.getQuests({
        offset: pageLimit * pageParam,
        limit: pageLimit,
        aggregationDisabled,
        chain,
        wallet: address,
      });
      return res.data;
    },
    initialPageParam: 0,
    getNextPageParam: (lastPage, allPages) => {
      return lastPage.length < pageLimit ? undefined : allPages.length;
    },
  });

  useEffect(() => {
    queryClient.invalidateQueries({ queryKey: ["quest-list", chain, address] });
  }, [chain, address, queryClient]);

  return infiniteQuery;
};

export { useQuest };
